import React, { Component } from "react";
import { Row, Col } from "antd";
import {
  LabelDataHeading,
  ValueDataHeading,
  Underlined,
  ContentDivider,
  ViewMoreButton
} from "../../../style";
import history from "../../../../../../../history/history";
import moment from "moment";
import { AlertMessagePrimary } from "../../AlertPopUp/AlertPopUp";
import { cancelReSchedule } from "../../../actions";
import { connect } from "react-redux";
import { getPrimaryAccount } from "../../../../../../../utils/sessionUtil";
import { recordError } from "../../../../../../../utils/commonUtil";
import { withRouter } from "react-router-dom";
import { isReadOnlyWithExchangeRole } from "../../../../RecommendAnExchangeNew/util";

export class RecurringExchangesCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: false,
      id: ""
    };
    this.handlePop = this.handlePop.bind(this);
  }

  handlePop(id) {
    this.setState({ popup: !this.state.popup, id });
  }

  cancelSingle() {
    this.setState({ popup: !this.state.popup });
    this.props.cancelReSchedule({
      method: "POST",
      page: "exchangeActivity",
      url: `/donor-portal/api/exchange/${
        getPrimaryAccount().userId
        }/cancelAllSpawnsForExchangeSchedule?exchangeScheduleId=${this.state.id}`
    });
  }

  render() {
    const { data } = this.props;
    let numvalue = data.noOfExchangesRemaining;
    if (numvalue < 10) numvalue = "0" + numvalue;
    let exchangeCreateDate = moment(
      moment.tz(data.exchangeCreateDate, "America/New_York")
    ).format("L");

    let nextScheduledExchangeDate = moment(
      moment.tz(data.nextScheduledExchangeDate, "America/New_York")
    ).format("L");
    return (
      <div>
        <AlertMessagePrimary
          title="Cancel Exchange"
          visible={this.state.popup}
          onCancel={() => this.handlePop()}
          onOk={() => this.cancelSingle()}
          width={800}
          cancelText="No, take me back"
          okText="CONTINUE"
        >
          Are you sure you want to cancel this exchange schedule? Canceling will
          delete all information entered for all upcoming spawns of this exchange.
        </AlertMessagePrimary>
        <Row>
          <Col span={12}>
            <LabelDataHeading>Entered Date</LabelDataHeading>
            <ValueDataHeading>
              {exchangeCreateDate === "Invalid date" ? (
                <div>&mdash;</div>
              ) : (
                  exchangeCreateDate
                )}
            </ValueDataHeading>
          </Col>
          <Col span={12}>
            <LabelDataHeading>Allocation Type</LabelDataHeading>
            <ValueDataHeading>
              {data.allocationType.toLowerCase()}
            </ValueDataHeading>
          </Col>
        </Row>
        <ContentDivider />
        <Row>
          <Col span={12}>
            <LabelDataHeading>Frequency</LabelDataHeading>
            <ValueDataHeading>{data.frequency}</ValueDataHeading>
          </Col>
          <Col span={12}>
            <LabelDataHeading>Next Scheduled <br />Date</LabelDataHeading>
            <ValueDataHeading>
              {nextScheduledExchangeDate === "Invalid date" ? (
                <div>&mdash;</div>
              ) : (
                  nextScheduledExchangeDate
                )}
            </ValueDataHeading>
          </Col>
        </Row>
        <ContentDivider />
        <Row>
          <Col span={12}>
            <LabelDataHeading>
              Number of Remaining
              <br />
              Exchanges
            </LabelDataHeading>
            <ValueDataHeading>{numvalue}</ValueDataHeading>
          </Col>
          <Col span={12}>
            <LabelDataHeading>Status</LabelDataHeading>
            <ValueDataHeading>{data.status}</ValueDataHeading>
          </Col>
        </Row>
        <ContentDivider />
        <Row>
          <Col span={8}>
            {data.status == "Active" &&
            (getPrimaryAccount().role.access == "All Access" || isReadOnlyWithExchangeRole()) ? (
              
                <ViewMoreButton
                data-test="view-more-1"
                  onClick={e => {
                    try {
                      e.stopPropagation();
                      history.push({
                        pathname: `/investments/recommend-an-exchange/${data.exchScheduleId}/view`,
                        search: 'type=recurring',
                        state: { txn: data }
                      });
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >
                  View & Edit
                </ViewMoreButton>

              ) : (

                <ViewMoreButton
                  data-test="view-more-1"
                  onClick={e => {
                    try {
                      e.stopPropagation();
                      history.push({
                        pathname: `/investments/recommend-an-exchange/${data.exchScheduleId}/view`,
                        search: 'type=recurring',
                        state: { txn: data }
                      });
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >
                  View
                </ViewMoreButton>
              )}
          </Col>

          <Col span={8} offset={4}>
            {data.status == "Active" &&
            (getPrimaryAccount().role.access == "All Access" || isReadOnlyWithExchangeRole()) ? (
              <Underlined
              data-test="data-underlined"
                onClick={() => {
                  this.handlePop(data.exchScheduleId);
                }}
              >
                Cancel
              </Underlined>
            ) : (
              <> </>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

export const mapDispatchToProps = dispatch => ({
  cancelReSchedule: data => dispatch(cancelReSchedule(data))
});

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(RecurringExchangesCard)
);
